/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyEngine_Models_SEPostSurveyScheduleOperation {
    NONE = 'none',
    CONFIRM = 'confirm',
    RESCHEDULE = 'reschedule',
    RESCHEDULE_OVERFLOW = 'rescheduleOverflow',
    CANCEL = 'cancel',
}
